import { GemsService } from './shared/services/gems.service';
import { AuthService } from './shared/services/auth.service';
import { concatMap, delay, filter, take, tap } from 'rxjs/operators';
import { forkJoin, from, of } from "rxjs";
import { ISitemap } from '@neb/lit-storybook';
import { googleTagInitialize } from './shared/functions';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

export const AppInitialize = (
  authService: AuthService,
  gemsService: GemsService,
  router: Router,
  route: ActivatedRoute
) => {
  return async () => {
    // if auth add env file!
    const sitemap$ = of(console.log('Start Up: Sitemap - fetching')).pipe(
      concatMap(() => gemsService.siteMap()),
      tap((x: ISitemap) => googleTagInitialize(x.google_analytics)),
      take(1),
      tap(() => console.log('Start Up: Sitemap - success')),
    );

    const authDelay$ = from('Start Up: starting').pipe(
      take(1),
      tap(() => console.log('Start Up: isAuthenticated', authService.isAuthenticated())),
      tap(() => console.log('Start Up: start delay')),
      delay(250),
      tap(() => console.log('Start Up: end delay')),
      tap(() => console.log('Start Up: isAuthenticated', authService.isAuthenticated())),
    );

    const pipe$ = authDelay$.pipe(
      concatMap(x => {
        if (!x) return of(null);

        return forkJoin({
          sitemap: sitemap$
        });
      })
    );

    let value = await authService.authenticate().toPromise();

    if (value) {
      await pipe$.toPromise();

      router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        filter(x => x.url.includes('?code='))
      ).subscribe((event: NavigationEnd) => {
        router.navigate([], {
          relativeTo: route,
          queryParams: {},
          replaceUrl: true
        });
      });
    }
    else authService.redirectToLogin();
  };
};
